import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const closestTask = async () =>
  await requestSdk(() =>
    get(`${BASE_URL}/v1/trackers/assignments/get-closest-task/`)
  );
